<template>
 



  <section  v-if="variants.v1 === variant" class="tw-relative tw-h-[80vh] tw-w-screen">
  <!-- Mobil video -->
  <video
    v-if="isMobileDevice && vars.mobileBackgroundVideo"
    :src="vars.mobileBackgroundVideo"
    class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
    autoplay
    muted
    loop
    playsinline
  ></video>

  <!-- Masaüstü video -->
  <video
    v-else-if="vars.backgroundVideo"
    :src="vars.backgroundVideo"
    class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
    autoplay
    muted
    loop
    playsinline
  ></video>

  <!-- Fotoğraf -->
  <img
    v-else-if="vars.photoImage"
    :src="vars.photoImage"
    alt="Background"
    class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
  />

  <!-- İçerik -->
  <div class="tw-absolute tw-inset-0 tw-z-50 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center">
    <h2 class="tw-max-w-4xl tw-text-white">
      {{ vars.titleText }}
    </h2>
    <p class="tw-mt-12 tw-max-w-4xl tw-text-white">
      {{ vars.descriptionText }}
    </p>
    <div v-if="buttons" class="tw-mt-12 tw-flex tw-flex-wrap tw-gap-6">
      <nuxt-link
        v-for="(button, idx) in buttons"
        :key="`btn-${idx}`"
        :to="button.link"
        :class="[
          'tw-inline-flex tw-items-center tw-gap-2 tw-rounded-lg tw-px-6 tw-py-3 tw-font-semibold tw-transition-all tw-duration-300',
          buttons.length > 1 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto',
          `n-${button.type}`,
        ]"
      >
        {{ button.label }}
      </nuxt-link>
    </div>
  </div>
</section>

 <section 
    class="n-section-primary tw-flex tw-flex-col tw-items-center tw-justify-center tw-overflow-hidden"
    v-if="variants.v2 === variant"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
  
    <div class="tw-z-10 tw-mb-12 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-text-center">
      
      <h2>{{ vars.titleText }}</h2>
    </div>
    <div v-if="vars.videoUrl" class="tw-relative tw-z-10 tw-w-full tw-max-w-[900px] tw-overflow-hidden">
      <library-iframe :src="vars.videoUrl" class="tw-h-full tw-w-full" :h-ratio="9" :w-ratio="16" />
    </div>
    
  </section>

</template>

<script lang="ts">
import { defineNuxtComponent } from '#app';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'SingleVideo',
  mixins: [ComponentMixin],

  data() {
    return {
      variants: { v1: 'v1', v2: 'v2', },
      isPlaying: false as boolean,
    };
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    cards() {
      return this.groupedVariables.cards;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
  methods: {
    togglePlay() {
      const vid = this.$refs.bgVideo as HTMLVideoElement | undefined;
      if (!vid) return;

      if (vid.paused) {
        vid.play();
        this.isPlaying = true;
      } else {
        vid.pause();
        this.isPlaying = false;
      }
    },
  },
});
</script>
